<sbnb-thermostat-setup-success-wrapper>
  <div class="grid justify-items-center gap-3 mb-10">
    <sbnb-icon [size]="48" [icon]="config.icon"></sbnb-icon>
    <h4 class="text-night">{{ config.title }}</h4>
  </div>

  <h2 class="mb-10">What temperature should the property be {{ config.question }}?</h2>

  <p class="mb-8 mt-0" *ngIf="config.description">{{ config.description }}</p>

  <div *ngIf="!thermostatPreset" class="mb-8 grid justify-items-center">
    <mat-spinner diameter="24"></mat-spinner>
  </div>

  <ng-container *ngIf="thermostatPreset">
    <div class="grid grid-cols-[1fr_auto_1fr] items-center">
      <div class="flex items-center gap-2">
        <sbnb-icon icon="matches-fire" class="text-coral"></sbnb-icon>
        <span>Heating Setpoint</span>
        <h4 class="font-extrabold text-coral">
          {{ thermostatPreset.heating_set_point_fahrenheit | number: '1.0-0' }}
        </h4>
      </div>

      <span>°F</span>

      <div class="flex items-center gap-2 justify-self-end">
        <h4 class="font-extrabold text-aqua">
          {{ thermostatPreset.cooling_set_point_fahrenheit | number: '1.0-0' }}
        </h4>
        <span>Cooling Setpoint</span>
        <sbnb-icon icon="temperature-snowflake" class="text-aqua"></sbnb-icon>
      </div>
    </div>

    <ngx-slider
      class="mt-10 mb-10"
      [(value)]="thermostatPreset.heating_set_point_fahrenheit"
      [(highValue)]="thermostatPreset.cooling_set_point_fahrenheit"
      [options]="options"></ngx-slider>
  </ng-container>

  <ng-content></ng-content>

  <sbnb-button
    class="mt-10 justify-self-end"
    [loading]="submitLoading"
    [disabled]="!thermostatPreset"
    (click)="onContinue()">
    Continue
  </sbnb-button>
</sbnb-thermostat-setup-success-wrapper>
